<template>
    <section class="loginOut">
        <!-- 主题切换 -->
        <ThemeSwitcher />
        <!-- 语言 -->
        <Language />
        <!-- 账号头像 -->
        <div class="topbar-avatar" @click="$router.push({ path: '/material' })">
            <img v-if="avatarUrl" :src="avatarUrl" alt="avatar" />
            <span v-else>{{ avatarText }}</span>
        </div>
        <!-- 用户 -->
        <section class="userName">
            <el-dropdown trigger="hover" :hide-on-click="false">
                <span :title="$store.getters.userInfo.user.username" class="el-dropdown-link">
                    <span>{{ $store.getters.userInfo.user.username }}</span>
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </span>

                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="$router.push({ path: '/material' })">
                        <i class="iconfont icon-gerenxinxi"></i>
                        {{ $t('selectMsg.EditProfile') }}
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <el-dropdown placement="left" v-if="$store.state.type === -1">
                            <span class="el-dropdown-link">
                                <i class="el-icon-back"></i>
                                {{ $t('integration.switch_proxy_customers') }}
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="item in switch_scope" :key="item.id"
                                    @click.native="proxyClick(item)">
                                    <!-- <i class="iconfont icon-gerenxinxi"></i> -->
                                    <span :class="userInfo.scope.customerId === item.id ? 'active' : ''">
                                        {{ item.name }}
                                    </span>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-dropdown-item>

                    <!-- 查询码 -->
                    <!-- <el-dropdown-item @click.native="$router.push({ path: '/findCode' })">
                        <i class="iconfont icon-erweima"></i><span style="margin-left:5px;font-size: 12px;">{{
                            $t('integration.query_code') }}</span>
                    </el-dropdown-item> -->
                    <!-- 设备注册 -->
                    <el-dropdown-item @click.native="deviceKeyDialog">
                        <i class="iconfont icon-barcode-line"></i><span style="margin-left:5px;font-size: 12px;">{{
                            $t('integration.device_enrollment') }}</span>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </section>
        <!-- <RangePage v-if="isType" /> -->
        <section class="imgLoginOut">
            <img :src="loginOut" :title="$t('selectMsg.Logout')" @click="handleClose" />
        </section>

        <!-- <DeviceKeyDialog v-if="isShowDeviceKeyDialog" :isShow.sync="isShowDeviceKeyDialog"
            @nextStep3="nextStep3"></DeviceKeyDialog>

        <PlanDialog v-if="isShowPlanDialog" :isShow.sync="isShowPlanDialog"
         ></PlanDialog> -->


         <div v-if="isShowDeviceKeyDialog" >
            <component :is="currentComponent" :isShow.sync="isShowDeviceKeyDialog" @nextStep3="nextStep3"></component>
         </div>

         <div v-if="isShowPlanDialog" >
            <component :is="currentComponent2" :isShow.sync="isShowPlanDialog"></component>
         </div>


    </section>
</template>

<script>
import Cookies from 'js-cookie'
import Language from '@/components/LangSelect';
import ThemeSwitcher from '@/components/ThemeSwitcher';
import { userLoginOut } from '@/api/api';

// brian 2022 04 23
import { mineSwitch } from '@/api/modules/indexPage.js';

// brian 2022 04 23
import { mapGetters } from 'vuex';
export default {
    inject: ['reload'],
    components: {
        Language,
        ThemeSwitcher
        // RangePage
    },
    computed: {
        ...mapGetters(['switch_scope', 'userInfo', 'avatar']),
        avatarUrl () {
            return this.$store.getters.avatar || ''
        },
        avatarText () {
            const name = this.$store.getters.userInfo && this.$store.getters.userInfo.user && this.$store.getters.userInfo.user.username
            return name ? name.substring(0, 2).toUpperCase() : ''
        }
    },
    data() {
        return {
            loginOut: require('@/assets/images/img/loginout.png'),
            isShowDeviceKeyDialog: false,
            isShowPlanDialog: false,
            currentComponent: null,
            currentComponent2: null
        };
    },
    mounted() { },
    methods: {
        handleClose() {
            this.$confirm(this.$t('messageTitle.ConfirmToLogOutOfAccount'))
                .then(_ => {
                    // 退出前清除数据
                    userLoginOut().then(res => {
                        if (res.state.code == 200) {
                            this.$store.state.tagsView.visitedViews = [];
                            window.sessionStorage.clear();
                            // 清除本地缓存（主题色、头像等），避免下一个用户登录时读到上个用户的缓存
                            // 主题色会在登录后从服务器同步最新值（路由守卫 await syncThemeFromServer）
                            // 头像会在登录后从服务器强制请求（路由守卫 isFromLogin 分支）
                            window.localStorage.clear();
                            // 清除主题色 Cookie（兜底恢复来源）
                            Cookies.remove('app_theme_primary_color');
                            // 清除 vuex 中持久化的头像和用户信息（vuex-persistedState 会同步到 localStorage）
                            this.$store.commit('SET_AVATAR', '');
                            this.$store.commit('SET_USERINFO', { scope: null, user: {}, switchScope: [] });
                            this.$store.commit('SET_TREE_DATA', []);
                            this.$store.commit('SET_TREE_USER_ID', null);

                            this.$router.replace('/login');
                        } else {
                            this.$message.error(res.state.msg || this.$t('messageTitle.ExitFailed'));
                        }
                    });
                })
                .catch(_ => { });
        },
        handleCommand() {
            this.$router.push('/homepageset');
        },
        proxyClick(item) {
            if (this.userInfo.scope.customerId === item.id) return;
            mineSwitch({ customer: item.id }).then(({ result }) => {
                if (result === 200) {
                    this.$loading.show({
                        text: '切换中...'
                    });
                    setTimeout(() => {
                        this.$loading.hide();
                        this.$message.success($t('integration.switching_succeeded_c__please_log_in_again'));
                    }, 1500);
                    window.location.href = '/#refreshTree';
                } else if (result === 300) {
                    this.$message.error($t('integration.the_current_customer_is_already_a_selected_customer_and_does_not_need_to_be_switched'));
                } else {
                    this.$message.error(this.$t('public.unknown_error'));
                }
            });
        },
        // 系统向导功能
        handleGuide() {
            let { href } = this.$router.resolve({
                path: '/guide'
            });
            window.open(href, 'newwindow', 'height=700,width=1400,top=200,left=200,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no');
        },

        deviceKeyDialog(){
            this.isShowDeviceKeyDialog = true;
            this.currentComponent = () => import('@/pages/home/component/device/keyDialog.vue');
        },
        nextStep3(){
            this.isShowPlanDialog = true
            this.currentComponent2 = () => import('@/pages/home/component/device/planDialog.vue');
        },
    }
};
</script>

<style lang="scss" scoped>
.loginOut {
    width: auto;
    min-width: 200px;
    padding: 0px 25px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    z-index: 9;

    .topbar-avatar {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        overflow: hidden;
        flex-shrink: 0;
        border: 2px solid rgba(255, 255, 255, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #cfe0f5, #9fb8d8);
        font-size: 11px;
        font-weight: 600;
        color: var(--primary-color, #304e72);
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .userName {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
            font-size: 16px;
            color: #fff;

            span {
                display: inline-block;
                width: auto;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        i {
            color: #fff;
        }
    }

    .imgLoginOut {
        img {
            width: 20px;
            height: 20px;
        }
    }

    .mask-class {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba($color: #000000, $alpha: 0.5);
        z-index: 9999;
    }

    .mask-content-class {
        position: fixed;
        width: 400px;
        height: 400px;
        top: 50%;
        left: 50%;
        border-radius: 2px;
        transform: translate(-50%, -50%);
        background-color: #ffffff;
        box-sizing: border-box;
        z-index: 10000;

        .icon-class {
            text-align: right;
            margin-top: 5px;
            margin-right: 5px;
            cursor: pointer;
        }

        .el-icon-error {
            font-size: 20px;
        }

        .content-classs {
            padding-left: 50px;
            padding-right: 50px;
        }

        p {
            text-align: center;
        }

        .refresh-class {
            margin-top: 15px;
            text-align: center;

            i {
                font-size: 24px;
                font-weight: bold;
            }
        }
    }
}

.active {
    color: #00eeff;
    font-weight: bold;
    font-size: 16px;
}

.el-dropdown-link {
    margin-top: 2px;
    display: flex;
    align-items: center;

    span {
        display: inline-block;
        height: 20px;
    }
}</style>
